module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/instagram/chapel_sns_03-7a62d94adffda6f922c685b2dd080cb1.jpg";